import { atom, selector } from "recoil";
import { localStorageEffect } from "../storage";

export const recentKeywordState = atom<string[]>({
  key: ["recentKeywords", Math.random()].join("-"),
  default: [],
  effects: [localStorageEffect("recentKeywords")],
});

export const recentSearchSelector = selector({
  key: ["recentSearchSelector", Math.random()].join("-"),
  get: ({ get }) => {
    const value = get(recentKeywordState);
    return value;
  },
});
